import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ScenarioRefreshService {
  scenarioQueue: number[] = [];
  isRefreshing = false;
  refreshComplete$ = new Subject<void>();
  scenarioRefreshed$ = new Subject<number>();

  setQueue(ids: number[]) {
    this.scenarioQueue = ids;
    this.isRefreshing = ids.length > 0;
  }

  getNextScenario(): number | undefined {
    return this.scenarioQueue.shift();
  }

  hasMore(): boolean {
    return this.scenarioQueue.length > 0;
  }

  clearQueue() {
    this.scenarioQueue = [];
    this.isRefreshing = false;
  }

  notifyRefreshComplete() {
    this.refreshComplete$.next();
  }

  notifyScenarioRefreshed(scenarioId: number) {
    this.scenarioRefreshed$.next(scenarioId);
  }
}